module.exports = __webpack_public_path__ + "static/media/drunk.f2191f54.jpg";